// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';
import {ImageSrc} from 'docs/markdoc/attribute-types';

export const Image: MarkdocTagRegistration = {
  tag: 'image',
  component: 'Image',
  description: 'Displays an image',
  attributes: {
    src: {
      description: 'The path of the image to display',
      type: ImageSrc,
      errorLevel: 'critical',
      required: true,
      matches(config) {
        return config?.validationMetadata?.imageSources;
      },
    },
    alt: {
      description: 'The alt text for the image',
      type: String,
    },
    zoomable: {
      type: Boolean,
      description:
        'Display the image in a larger size in a modal popover when clicked',
    },
    width: {
      type: Number,
      errorLevel: 'critical',
      description:
        'The width of the image expressed as a percentage of the page. If not specified, defaults to 100% (unless a height is set)',
    },
    height: {
      type: String,
      errorLevel: 'critical',
      description:
        'The height of the image expressed using any CSS-compatible units',
    },
    zoomHeight: {
      type: String,
      errorLevel: 'critical',
      description:
        'The max height of the zoomed image expressed using any CSS-compatible units',
    },
    aside: {
      type: Boolean,
      description:
        'If provided, renders the image off to the right, similar to an `aside` tag',
    },
    inline: {
      type: Boolean,
      description: 'If provided, renders the image with display inline',
    },
    border: {
      type: Boolean,
      description:
        'Adds a visual border around the image to distinguish it from the page background',
    },
  },
};
